module.exports = XMLHttpRequest;



/*****************
 ** WEBPACK FOOTER
 ** ./~/xhr2/lib/browser.js
 ** module id = 4179
 ** module chunks = 0
 **/